import PropTypes from 'prop-types';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import * as CRMObjectTypes from 'automation-ui-references/object-types/CRMObjectTypes';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import ClassicVirtualAnchoredDelayActionMetadata from 'automation-ui-action-features/actions/classic-virtual-anchored-delay/records/ClassicVirtualAnchoredDelayActionMetadata';
import * as ClassicVirtualAnchoredDelayActionMetadataKeys from 'automation-ui-action-features/actions/classic-virtual-anchored-delay/constants/ClassicVirtualAnchoredDelayActionMetadataKeys';
import { jsx as _jsx } from "react/jsx-runtime";
const ClassicVirtualAnchoredDelayActionDetail = ({
  actionMetadata,
  eventAnchor
}) => {
  const {
    contactPropertyAnchor,
    staticDateAnchor
  } = eventAnchor;
  const recurAnnually = actionMetadata.get(ClassicVirtualAnchoredDelayActionMetadataKeys.RECUR_ANNUALLY);
  if (contactPropertyAnchor) {
    const options = {
      property: /*#__PURE__*/_jsx(Text, {
        as: "strong",
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(PropertyName, {
          objectTypeId: CRMObjectTypes.CONTACT_ID,
          propertyName: contactPropertyAnchor
        })
      })
    };
    return recurAnnually ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.classic-virtual-anchored-delay.action-detail.centeredOnPropertyAndRecur",
      options: options
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.classic-virtual-anchored-delay.action-detail.centeredOnProperty",
      options: options
    });
  } else if (staticDateAnchor) {
    const options = {
      date: /*#__PURE__*/_jsx(Text, {
        as: "strong",
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: new Date(staticDateAnchor),
          format: recurAnnually ? 'short-date' : 'll',
          type: "userTz"
        })
      })
    };
    return recurAnnually ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.classic-virtual-anchored-delay.action-detail.centeredOnDateAndRecur",
      options: options
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.classic-virtual-anchored-delay.action-detail.centeredOnDate",
      options: options
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.classic-anchored-delay.prompt"
  });
};
ClassicVirtualAnchoredDelayActionDetail.propTypes = {
  actionMetadata: PropTypes.instanceOf(ClassicVirtualAnchoredDelayActionMetadata).isRequired,
  eventAnchor: PropTypes.object.isRequired
};
export default ClassicVirtualAnchoredDelayActionDetail;